const feeling_config = {
  yAxisTitle: "How you felt.",
  xAxisTitle: "Journal Entry Date",
  yAxisLabels: ["0", "5"],
  yRange: [0, 5],
  dominantPage: "processing",
  margin: {
    desktop: {
      top: 12,
      right: 48,
      bottom: 48,
      left: 48,
    },
    mobile: {
      top: 12,
      right: 30,
      bottom: 36,
      left: 12,
    },
  },
};

const task_completion_config = {
  yAxisTitle: "How much you did.",
  xAxisTitle: "Journal Entry Date",
  yAxisLabels: ["0", "50"],
  yRange: [0, 50],
  dominantPage: "planning",
  margin: {
    desktop: {
      top: 12,
      right: 48,
      bottom: 48,
      left: 48,
    },
    mobile: {
      top: 12,
      right: 42,
      bottom: 36,
      left: 12,
    },
  },
};

const task_completion_rate_config = {
  yAxisTitle: "How much of your plan that you did",
  xAxisTitle: "Journal Entry Date",
  yAxisLabels: ["0%", "100%"],
  yRange: [0, 1],
  dominantPage: "planning",
  margin: {
    desktop: {
      top: 12,
      right: 72,
      bottom: 48,
      left: 48,
    },
    mobile: {
      top: 12,
      right: 60,
      bottom: 36,
      left: 12,
    },
  },
};

const wave_config = {
  yAxisTitle: "Your wave score.",
  xAxisTitle: "Journal Entry Date",
  yAxisLabels: ["0", "15"],
  yRange: [0, 15],
  dominantPage: "processing",
  margin: {
    desktop: {
      top: 12,
      right: 48,
      bottom: 48,
      left: 48,
    },
    mobile: {
      top: 12,
      right: 42,
      bottom: 36,
      left: 12,
    },
  },
};

const feeling_doing_config = {
  shortLabel: "Feeling x Doing",
  yAxisTitle: "How you felt.",
  xAxisTitle: "How much you did",
  yAxisLabels: ["0", "5"],
  yRange: [0, 5],
  xAxisLabels: ["0", "50"],
  xRange: [0, 50],
  // Nobody's days span the whole 0-50: held to the declared range this plot was
  // a knot of dots in the middle with no room to aim at one. RegressionChart
  // fits both axes to the days in view instead, keeping the ranges above as the
  // measure's own scale (the caps, the endpoint labels, ChartHeader's "/5").
  fitAxesToData: true,
  dominantPage: "processing",
  margin: {
    desktop: {
      top: 12,
      right: 48,
      bottom: 48,
      left: 48,
    },
    mobile: {
      top: 12,
      right: 36,
      bottom: 36,
      left: 36,
    },
  },
};

const morning_evening_config = {
  shortLabel: "Morning x Evening",
  yAxisTitle: "How you ended.",
  xAxisTitle: "How you started",
  yAxisLabels: ["0", "5"],
  yRange: [0, 5],
  xAxisLabels: ["0", "5"],
  xRange: [0, 5],
  // Same fix as feeling_doing: nobody scores across the whole 0-5, so the fixed
  // frame left the dots knotted together. sharedAxisScale keeps both axes on one
  // fitted domain - this graph is read as "above the diagonal means the day got
  // better", which is only true while the two axes step at the same rate.
  fitAxesToData: true,
  sharedAxisScale: true,
  dominantPage: "processing",
  margin: {
    desktop: {
      top: 12,
      right: 48,
      bottom: 48,
      left: 48,
    },
    mobile: {
      top: 12,
      right: 36,
      bottom: 36,
      left: 36,
    },
  },
};

const doing_shift_config = {
  shortLabel: "Doing x Day Shift",
  yAxisTitle: "How much your day shifted.",
  xAxisTitle: "Average moment score",
  yAxisLabels: ["-5", "5"],
  yRange: [-5, 5],
  xAxisLabels: ["0", "10"],
  xRange: [0, 10],
  dominantPage: "processing",
  margin: {
    desktop: {
      top: 12,
      right: 48,
      bottom: 48,
      left: 48,
    },
    mobile: {
      top: 12,
      right: 36,
      bottom: 36,
      left: 36,
    },
  },
};

const carryover_config = {
  shortLabel: "Yesterday x Today",
  yAxisTitle: "Today's start",
  xAxisTitle: "Yesterday's end",
  yAxisLabels: ["0", "5"],
  yRange: [0, 5],
  xAxisLabels: ["0", "5"],
  xRange: [0, 5],
  dominantPage: "processing",
  margin: {
    desktop: {
      top: 12,
      right: 48,
      bottom: 48,
      left: 48,
    },
    mobile: {
      top: 12,
      right: 36,
      bottom: 36,
      left: 36,
    },
  },
};

const moment_mix_config = {
  shortLabel: "Moment Mix",
  yAxisTitle: "Score vs. presence in plan",
  xAxisTitle: "Moment",
  yAxisLabels: ["0%", "100%"],
  yRange: [0, 1],
  dominantPage: "planning",
  margin: {
    desktop: {
      top: 12,
      right: 72,
      bottom: 48,
      left: 48,
    },
    mobile: {
      top: 12,
      right: 60,
      bottom: 36,
      left: 12,
    },
  },
};

const efficiency_doing_config = {
  yAxisTitle: "The percentage of your plan that you did.",
  xAxisTitle: "How much you did",
  yAxisLabels: ["0%", "100%"],
  yRange: [0, 1],
  xAxisLabels: ["0", "50"],
  xRange: [0, 50],
  dominantPage: "planning",
  margin: {
    desktop: {
      top: 12,
      right: 48,
      bottom: 48,
      left: 48,
    },
    mobile: {
      top: 12,
      right: 30,
      bottom: 36,
      left: 12,
    },
  },
};

export {
  feeling_config,
  task_completion_config,
  task_completion_rate_config,
  wave_config,
  feeling_doing_config,
  morning_evening_config,
  doing_shift_config,
  carryover_config,
  moment_mix_config,
};
